module.exports = __webpack_public_path__ + "assets/img/img74.6ab69689.png";